<template>
  <v-row dense align="center">
    <DatetimeRangePicker
      type="datetime"
      v-model="datetimeRange"
      v-if="!$vuetify.theme.dark"
      :label="
        radios == 'radio-created'
          ? $t('Order.Fields.created_time')
          : radios == 'radio-expect'
          ? $t('Order.Fields.expect_date')
          : radios == 'radio-actual'
          ? $t('Order.Fields.actual_time')
          : $t('Order.Fields.pay_time')
      "
      :removeIcon="removeIcon"
    >
      <template v-slot:header>
        <v-radio-group v-if="showRadio" v-model="radios" row hide-details>
          <v-radio
            :label="$t('Order.Fields.created_time')"
            value="radio-created"
          ></v-radio>
          <v-radio
            v-if="showRadioActual"
            :label="$t('Order.Fields.actual_time')"
            value="radio-actual"
          ></v-radio>
          <v-radio
            v-if="showRadioExpect"
            :label="$t('Order.Fields.expect_date')"
            value="radio-expect"
          ></v-radio>
          <v-radio
            v-if="showRadioPay"
            :label="$t('Order.Fields.pay_time')"
            value="radio-pay"
          ></v-radio>
        </v-radio-group>
        <v-divider />
      </template>
    </DatetimeRangePicker>
    <DatetimeRangePickerDark
      type="datetime"
      v-model="datetimeRange"
      v-if="$vuetify.theme.dark"
      :label="
        radios == 'radio-created'
          ? $t('Order.Fields.created_time')
          : radios == 'radio-expect'
          ? $t('Order.Fields.expect_date')
          : radios == 'radio-actual'
          ? $t('Order.Fields.actual_time')
          : $t('Order.Fields.pay_time')
      "
      :removeIcon="removeIcon"
    >
      <template v-slot:header>
        <v-radio-group v-if="showRadio" v-model="radios" row hide-details>
          <v-radio
            :label="$t('Order.Fields.created_time')"
            value="radio-created"
          ></v-radio>
          <v-radio
            v-if="showRadioActual"
            :label="$t('Order.Fields.actual_time')"
            value="radio-actual"
          ></v-radio>
          <v-radio
            v-if="showRadioExpect"
            :label="$t('Order.Fields.expect_date')"
            value="radio-expect"
          ></v-radio>
          <v-radio
            v-if="showRadioPay"
            :label="$t('Order.Fields.pay_time')"
            value="radio-pay"
          ></v-radio>
        </v-radio-group>
        <v-divider />
      </template>
    </DatetimeRangePickerDark>
  </v-row>
</template>

<style scoped>
.v-input--selection-controls {
  margin-top: 0;
  padding: 6px;
}
</style>

<script>
import DatetimeRangePicker from "@/plugins/datepicker/DatetimeRangePicker";
import DatetimeRangePickerDark from "@/plugins/datepicker/DatetimeRangePickerDark";

export default {
  name: "SearcherOrderDate",

  props: {
    value: Object,
    showRadio: Boolean,
    showRadioExpect: Boolean,
    showRadioActual: Boolean,
    showRadioPay: Boolean,
    removeIcon: Boolean,
  },

  components: {
    DatetimeRangePicker,
    DatetimeRangePickerDark,
  },

  data: () => ({
    radios: "radio-created",
    datetimeRange: [
      new Date().toISOString().substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
  }),

  methods: {
    changedVal() {
      if (!this.radios) return null;

      var newVal = {
        orderDatetimeRadios: this.radios,
        created_time_from:
          this.radios == "radio-created" && this.datetimeRange[0]
            ? this.datetimeRange[0]
            : "",
        created_time_to:
          this.radios == "radio-created" && this.datetimeRange[1]
            ? this.datetimeRange[1]
            : "",
        expect_time_from:
          this.radios == "radio-expect" && this.datetimeRange[0]
            ? this.datetimeRange[0]
            : "",
        expect_time_to:
          this.radios == "radio-expect" && this.datetimeRange[1]
            ? this.datetimeRange[1]
            : "",
        actual_time_from:
          this.radios == "radio-actual" && this.datetimeRange[0]
            ? this.datetimeRange[0]
            : "",
        actual_time_to:
          this.radios == "radio-actual" && this.datetimeRange[1]
            ? this.datetimeRange[1]
            : "",
        pay_time_from:
          this.radios == "radio-pay" && this.datetimeRange[0]
            ? this.datetimeRange[0]
            : "",
        pay_time_to:
          this.radios == "radio-pay" && this.datetimeRange[1]
            ? this.datetimeRange[1]
            : "",
      };

      if (
        this.value.orderDatetimeRadios == newVal.orderDatetimeRadios &&
        this.value.created_time_from == newVal.created_time_from &&
        this.value.created_time_to == newVal.created_time_to &&
        this.value.expect_time_from == newVal.expect_time_from &&
        this.value.expect_time_to == newVal.expect_time_to &&
        this.value.actual_time_from == newVal.actual_time_from &&
        this.value.actual_time_to == newVal.actual_time_to &&
        this.value.pay_time_from == newVal.pay_time_from &&
        this.value.pay_time_to == newVal.pay_time_to
      )
        return null;
      else return newVal;
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      deep: true,
      handler() {
        this.radios = this.value.orderDatetimeRadios;
        if (this.radios == "radio-created") {
          this.datetimeRange = [
            this.value.created_time_from,
            this.value.created_time_to,
          ];
        } else if (this.radios == "radio-expect") {
          this.datetimeRange = [
            this.value.expect_time_from,
            this.value.expect_time_to,
          ];
        } else if (this.radios == "radio-actual") {
          this.datetimeRange = [
            this.value.actual_time_from,
            this.value.actual_time_to,
          ];
        } else if (this.radios == "radio-pay") {
          this.datetimeRange = [
            this.value.pay_time_from,
            this.value.pay_time_to,
          ];
        }
      },
    },
    radios: {
      handler() {
        var changedVal = this.changedVal();
        if (changedVal)
          this.$emit("input", Object.assign({}, this.value, changedVal));
      },
    },
    datetimeRange: {
      handler() {
        var changedVal = this.changedVal();
        if (changedVal)
          this.$emit("input", Object.assign({}, this.value, changedVal));
      },
    },
  },
};
</script>
